function EventListener(vm)  {

  this.vm = vm;
  this.xhr = null;

  this.retries = ko.observable(0);
  this.wasSuccessful = ko.observable(false);
  this.isRetryInProgress = ko.observable(false);
  this.isConnected = ko.computed(this.isConnected, this);
  this.isRetrying = ko.computed(this.isRetrying, this);

  this.openedTime = 0;
  this.loadedTime = 0;

  this.eventNumber = 0;
  this.lastEventReceived;
  this.responseIdx = 0;
  this.qlessPageId = Date.now();

  this.retryHandle = null;
  this.reloadHandle = null;

  this.MAX_RETRIES = 24;
  this.TIMEOUT = 120000; // 120 seconds / 2 minutes
  this.WSSID_REFRESH_THRESHOLD = 5;
  this.STAY_OPEN_THRESHOLD = 2000;

  this.eventURL = function () {
    var path = this.apiPath();
    return path + "?id=" + this.qlessPageId;
  };

  this.handleStateChange = function (request) {
    if (!isUsableRequest(request)) {
      this.retry("No XHR");
      return;
    }

    if (isRequestOpen(request)) {
      this.openedTime = Date.now();
      this.log("XHR open");
    }

    if (isRequestSent(request)) {
      this.log("XHR sent");

      if (!request.status) {
        this.log("XHR waiting for HTTP status and headers")
      }

      if (this.vm.isDebugMode()) {
        this.log("response")
        console.dir({
          "readyState": request.readyState,
          "headers": parseHeaders(request.getAllResponseHeaders()),
          "responseText": request.responseText,
          "status": request.status,
          "statusText": request.statusText,
          "responseType": request.responseType
        });
      }

      if (request.status) {
        this.wasSuccessful(isResponseOK(request) || this.didStayOpen());

        if (this.wasSuccessful()) {
          if (this.isRetryInProgress()) {
            this.abortRetries();
            this.refreshWSSID();
          }
        }
      }
    }

    // N.B. This must occur before we use this.didStayOpen() since it depends on `this.loadedTime`
    if (isRequestDone(request)) {
      this.loadedTime = Date.now();
      this.log("XHR loaded (completed)");

      if (this.vm.isDebugMode()) {
        this.log("response")
        console.dir({
          "readyState": request.readyState,
          "headers": parseHeaders(request.getAllResponseHeaders()),
          "responseText": request.responseText,
          "status": request.status,
          "statusText": request.statusText,
          "responseType": request.responseType
        });
      }
    }

    if (isRequestLoading(request)) {
      this.log("XHR loading");

      if (this.vm.isDebugMode()) {
        this.log("response")
        console.dir({
          "readyState": request.readyState,
          "responseText": request.responseText,
        });
      }

      this.handleProgress(request);
    }

    if (isRequestDone(request)) {
      this.handleLoad(request);
    }

    if (isUnkownReadyState(request)) {
      // TODO: This block is probably unecessary
      this.logError("Unknown readyState: " + request.readyState + "; status: " + request.status);
      this.reload("Failed: unknown readyState");
    }
  };

  this.handleProgress = function (request) {
    // request is loading, we are receiving the response/partial text (events)
    if (isResponseOK(request)) {
      this.interactive(request);
    }
  };

  this.handleError = function (request) {
    this.wasSuccessful(false);
    this.log(
      "Event Connection detected an error" +
      "; ReadyState: " + request.readyState +
      "; HTTP Status: " + request.status);
  };

  this.handleLoad = function (request) {
    this.process(request);
  };

  this.poll = function () {
    try {
      this.xhr = createXMLHttpRequest();

      this.xhr.onreadystatechange = function () {
        this.handleStateChange(this.xhr);
      }.bind(this);

      this.xhr.onerror = function () {
        this.handleError(this.xhr);
      }.bind(this);

      this.xhr.ontimeout = function () {
        this.log("XHR ontimeout");
      }.bind(this);

      this.xhr.onload = function() {
        this.log("XHR onload"); 
      }.bind(this);

      this.xhr.open("GET", this.eventURL() + "&_=" + Date.now(), true);

      // You can only set the timeout, in IE, after open and before send
      this.xhr.timeout = this.TIMEOUT;

      this.xhr.send();
    } catch (e) {
      this.logError(e);
      this.reload("Unable to create XHR");
    }
  };

  this.process = function (request) {
    try {
      if (this.wasSuccessful()) {
        this.responseIdx = 0;
        this.resume();
      } else {
       this.retry("XHR loaded unsuccessfully" + (request.status) ? "; Status: " + request.status : "");
      }
    } catch (e) {
      this.retry(e);
    }
  };

  this.interactive = function (transport) {
    try {
      var response = transport.responseText.substring(this.responseIdx);
      this.responseIdx = transport.responseText.length;
      this.handleEvent(response);
    } catch (e) {
      window.Sentry && window.Sentry.captureException(e);
    }
  };

  this.handleEvent = function (evt) {
    this.vm.eventsWS.handleMessage(evt);
    this.eventNumber++;
    this.lastEventReceived = new Date();
  };

  this.reload = function (message) {
    this.log("Reload browser" + (message) ? ": " + message : "");
    this.reloadHandle = setTimeout(function () { window.location.reload(); });
  };

  this.exceptionToString = function (err) {
    var rtn = "{";

    if (typeof err != "string") {
      for (var prop in err) {
        rtn += prop + "=[" + err[prop] + "], ";
      }
    }

    rtn += "toString()=[" + err.toString() + "]}";

    return rtn;
  },

  this.logError = function (err) {
    try {
      this.log(err);
      window.Sentry.captureException(err);
      // QM previously shunted error messages to Linebuster
      // var url = "/qless/api/v1/error?error=" + encodeURIComponent(this.exceptionToString(err));
    } catch (e) {
      window.Sentry && window.Sentry.captureException(e);
    }
  };
}

function createXMLHttpRequest() {
  try {
    return new XMLHttpRequest();
  } catch (e) {
    try {
      return new ActiveXObject("Msxml2.XMLHTTP");
    } catch (f) {
      try {
        return new ActiveXObject("Microsoft.XMLHTTP");
      } catch (g) {
        window.Sentry && window.Sentry.captureException(g);
        return null;
      }
    }
  }
}

EventListener.prototype = Object.create({})

EventListener.prototype.API_PATH = "/qless/event/v1/employee";

EventListener.prototype.apiPath = function () {
  return this.API_PATH;
}

/**
 * Reopens the Event connection after unsuccessful attempts to open a connection,
 * unexpected closure by the server, or network interruptions.
 *
 * @param {string} message the reason for increasing the retry count and delay.
 */
EventListener.prototype.retry = function (message) {
  if (this.retryHandle) {
    // Retry already scheduled, do nothing.
    return;
  }

  this.retries(this.retries() + 1);

  if (this.retries() < this.MAX_RETRIES) {
    this.retryHandle = setTimeout(function () {
      var retryDelay = this.retryDelay();

      this.log(
        "Retry" +
        ((message) ? ": " + message : "") +
        "; Attempt: " + this.retries() +
        "; Delay: " + retryDelay / 1000 + "s"
      );

      this.retryHandle = undefined;
      this.isRetryInProgress(true);

      if (this.shouldRefreshPageId()) {
        this.refreshPageId();
      }

      this.poll();
    }.bind(this), this.retryDelay());

  } else {
    this.logError(message);
    this.reload("Retry attempts exceeded");
  }
};

EventListener.prototype.retryDelay = function () {
  if (this.retries() <= 5) {
    return 2000;
  }

  if (this.retries() > 5) {
    return 5000;
  }
};

/**
 * Reopens the Event Connection after successful connection was closed by the Server.
 */
EventListener.prototype.resume = function () {
  this.retries(0);
  this.log("Resume");
  setTimeout(this.poll.bind(this));
};

/**
 * Forcibly end the XHR used for the Event connection.
 * This method is only used by Developers for debugging/testing.
 *
 */
EventListener.prototype._abort = function () {
  this.log("Abort request");
  this.xhr.abort();
};

EventListener.prototype.abortRetries = function () {
  this.retries(0);
  this.isRetryInProgress(false);

  if (this.retryHandle) {
    clearInterval(this.retryHandle);
  }

  this.log("Abort retries");
}

EventListener.prototype.shouldRefreshWSSID = function shouldRefreshWSSID() {
  return (this.retries() >= this.WSSID_REFRESH_THRESHOLD);
}

EventListener.prototype.refreshWSSID = function refreshWSSID() {
  if (this.shouldRefreshWSSID()) {
    this.log("Refresh WSSID");
    this.vm.wssidWS.doRequest();
  }
};

EventListener.prototype.shouldRefreshPageId = function shouldRefreshPageId() {
  return false;
};

EventListener.prototype.refreshPageId = function refreshPageId() {
  this.qlessPageId = new Date().getTime();
}

EventListener.prototype.isRetrying = function () {
  var isRetryInProgress = this.isRetryInProgress()
  return isRetryInProgress;
}

EventListener.prototype.isConnected = function () {
  var isSuccess = this.wasSuccessful();
  var isRetrying = this.isRetrying();
  return isSuccess && !isRetrying;
}

EventListener.prototype.log = function (message) {
  var prefix = "event-listener - ";
  this.vm.conlog(prefix + message)
}

/**
 * Make all attempts to open the Event connection abort immediately.
 * This may help to simulate the connection being offline.
 */
EventListener.prototype._enableForceAbort = function () {
  if (this._preForceAbortState === undefined) {
    this._preForceAbortState = {
      "apiPath": this.apiPath,
      "handleStateChange": this.handleStateChange.bind(this)
    };
  }

  console.warn("Enabled Force Abort");

  this.apiPath = function () {
    return "cec/enableForceAbort"
  };

  this.handleStateChange = function (request) {
    console.warn("Forced abort is enabled!");
    if (!isRequestUnsent(request) && !isRequestDone(request)) {
      this._abort();
    }

    this._preForceAbortState.handleStateChange(request);
  };

  this._abort();
};

/**
 * Undo the effects of `enableForceAbort`
 */
EventListener.prototype._disableForceAbort = function () {

  console.warn("Disabled Force Abort");

  if (this._preForceAbortState !== undefined) {
    this.apiPath = this._preForceAbortState.apiPath;
    this.handleStateChange = this._preForceAbortState.handleStateChange;
  }
};


EventListener.prototype.didStayOpen = function () {
  return (this.loadedTime - this.openedTime) >= this.STAY_OPEN_THRESHOLD;
}

function isUsableRequest(request) {
  if (typeof request === "undefined" || request === null) {
    return false;
  }

  if (typeof request.status === "undefined") {
    return false;
  }

  return true;
}

function isRequestUnsent(request) {
  return request.readyState === 0;
}

function isRequestOpen(request) {
  return request.readyState === 1;
}

function isRequestSent(request) {
  return request.readyState === 2;
}

function isRequestLoading(request) {
  return request.readyState === 3;
}

function isRequestDone(request) {
  return request.readyState === 4;
}

function isUnkownReadyState(request) {
  return request.readyState < 0 || request.readyState > 4;
}

function isResponseOK(request) {
  return request.status >= 200 && request.status < 300;
}

function parseHeaders(s) {
  return s
    .trim()
    .split(/[\r\n]+/)
    .reduce(function (headers, header) {
      var headerParts = header.split(": ");
      var name = headerParts.shift();
      var value = (headerParts.length >= 1) ? headerParts.join(" : ") : "";
      headers[name] = value;

      return headers;
    }, {});
}

module.exports = EventListener;
